import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "pad15",
  style: {"height":"90vh"}
}
const _hoisted_2 = { class: "h20" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_5 = {
  class: "ofs RoomHistoryDetailModalScroll noscroll",
  style: {"height":"calc(90vh - 50px)"}
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "title mc",
  style: {"width":"240px"}
}, [
  /*#__PURE__*/_createElementVNode("p", {
    class: "header_title fs24 centered",
    style: {"color":"#696969"}
  }, "出席者情報を変更")
], -1)
const _hoisted_7 = {
  class: "text pad20",
  style: {"color":"#696969"}
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "fl fs14 fw600 ddgrey mb5 text-left" }, "出席者", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_10 = {
  class: "fl ml5",
  style: {}
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_13 = { class: "mt20" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "fl fs14 fw600 ddgrey mb5 text-left" }, "日程決定", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_16 = {
  class: "fl ml5",
  style: {}
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_18 = {
  key: 0,
  class: "w100 fl"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", {
  for: `send_mail_fix_member_`,
  class: "fs12 pointer"
}, " 日程決定者へ通知するメールにメッセージをつける", -1)
const _hoisted_20 = { key: 0 }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_23 = {
  class: "w100 posAb",
  style: {"bottom":"0"}
}
const _hoisted_24 = {
  class: "posAb w50 centered",
  style: {"left":"0","bottom":"0"}
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "fs14 fw400" }, "閉じる", -1)
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = {
  class: "posAb w50 centered",
  style: {"right":"0","bottom":"0"}
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "fs14 whiteColor fw600" }, "変更", -1)
const _hoisted_29 = [
  _hoisted_28
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_progress_bar = _resolveComponent("md-progress-bar")!
  const _component_MdRadioButtonTag = _resolveComponent("MdRadioButtonTag")!
  const _component_CheckboxTag = _resolveComponent("CheckboxTag")!
  const _component_TextareaTag = _resolveComponent("TextareaTag")!
  const _component_VueFinalModal = _resolveComponent("VueFinalModal")!

  return (_openBlock(), _createBlock(_component_VueFinalModal, {
    "modal-id": "ChangeMemberInfoModal",
    "content-class": "rad10 with_white_bg shadowContent modalStandard noscroll",
    onBeforeOpen: _ctx.openModal
  }, {
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_md_progress_bar, { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: _ctx.$getAssetImageUrl(`/assets/popUp/close_dark_grey.png`),
            width: "30",
            height: "30",
            class: "fr pointer",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args)))
          }, null, 8, _hoisted_3)
        ]),
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", null, [
              _hoisted_8,
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_MdRadioButtonTag, {
                  options: [
                                    { name: `必須`, id: `require` },
                                    { name: `任意`, id: `option` },
                                    { name: `オブザーバー`, id: `observer` },
                                ],
                  optionName: `select_attendee_type`,
                  defaultOption: _ctx.attendeeType == 10 ? `require` : `option`,
                  type: `horizon`,
                  onSelect: _ctx.selectAttendeeType
                }, null, 8, ["defaultOption", "onSelect"]),
                _hoisted_11
              ]),
              _hoisted_12
            ]),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _hoisted_15,
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_MdRadioButtonTag, {
                  options: [
                                    { name: `可能`, id: `fix` },
                                    { name: `不可`, id: `none` },
                                    { name: `不可（投票日程確認可能）`, id: `watch` },
                                ],
                  optionName: `select_assign_type`,
                  defaultOption: _ctx.assignType,
                  type: `horizon`,
                  onSelect: _ctx.selectAssignType
                }, null, 8, ["defaultOption", "onSelect"]),
                _hoisted_17,
                (_ctx.canShowSendFixMemberFlg)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _createVNode(_component_CheckboxTag, {
                        value: ``,
                        name: `send_mail_fix_member`,
                        checked: _ctx.sendMailFixMember,
                        prefix: `send_mail_fix_member`,
                        onClickCheckbox: _ctx.clickSendMailFixMember,
                        class: "ml1"
                      }, null, 8, ["checked", "onClickCheckbox"]),
                      _hoisted_19,
                      (_ctx.sendMailFixMember)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                            _createVNode(_component_TextareaTag, {
                              placeholder: "全員の予定が集まりましたら日程の確定をお願いいたします。",
                              style: {"height":"120px"},
                              class: "fs14 roundForm mw100",
                              value: _ctx.message,
                              onInputValue: _ctx.inputMessage
                            }, null, 8, ["value", "onInputValue"])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_21
            ]),
            _hoisted_22
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("section", {
            class: "with_white_bg dgrey fs16 pointer centered",
            style: {"line-height":"50px","height":"50px"},
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.cancelInput && _ctx.cancelInput(...args)))
          }, _hoisted_26)
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("section", {
            class: "w100 skyblueBg fs16 pointer centered",
            style: {"line-height":"50px","height":"50px"},
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.send && _ctx.send(...args)))
          }, _hoisted_29)
        ])
      ])
    ]),
    _: 1
  }, 8, ["onBeforeOpen"]))
}